import React from 'react';
import { Link } from 'react-router-dom';

import * as S from './styles';
import { IProps } from './types';
import IconClipboardCheck from '../../../images/icons/clipboard-check-solid.svg';
import IconAngleRight from '../../../images/icons/angle-right-solid.svg';
import IconComments from '../../../images/icons/comments-solid.svg';
import IconCoins from '../../../images/icons/coins-solid.svg';
import IconVoucher from '../../../images/icons/voucher.svg';
import IconWishList from '../../../images/icons/bookmark_black.svg';
import IconUsers from '../../../images/icons/users-solid.svg';
import IconLock from '../../../images/icons/lock-solid.svg';
import IconIdCard from '../../../images/icons/id-card-alt-solid.svg';
import IconSearch from '../../../images/icons/search-solid.svg';
import IconLogout from '../../../images/icons/sign-out-alt-solid.svg';
import { ListGroup } from 'react-bootstrap';
import { CredentialContext, credentialType } from '@src/providers';
import useIsComDomain from '@src/hooks/useIsComDomain';
import {
  orderListUrl,
  reviewListUrl,
  pointListUrl,
  shareUrl,
  changePasswordUrl,
  contactUrl,
  baseUrl,
  wishListUrl,
  voucherListUrl,
  mstiTestUrl,
} from '@src/app/routes';

const MyAccountMenu: React.FC<IProps> = ({}: IProps) => {
  const isComDomain = useIsComDomain();
  const { currentUser, logOut } = React.useContext<credentialType>(CredentialContext);

  return (
    <S.Wrapper>
      <ListGroup>
        <Link to={orderListUrl}>
          <ListGroup.Item>
            <img src={IconClipboardCheck} width={10} />
            <S.ListItemText>My Orders</S.ListItemText>
            <img src={IconAngleRight} width={10} style={S.FaRight} />
          </ListGroup.Item>
        </Link>
        <Link to={reviewListUrl}>
          <ListGroup.Item>
            <img src={IconComments} width={14} />
            <S.ListItemText>My Review</S.ListItemText>
            <img src={IconAngleRight} width={10} style={S.FaRight} />
          </ListGroup.Item>
        </Link>
        {!isComDomain ? (
          <Link to={pointListUrl}>
            <ListGroup.Item>
              <img src={IconCoins} width={14} />
              <S.ListItemText>My Points</S.ListItemText>
              <img src={IconAngleRight} width={10} style={S.FaRight} />
            </ListGroup.Item>
          </Link>
        ) : null}
        <Link to={voucherListUrl}>
          <ListGroup.Item>
            <img src={IconVoucher} width={14} />
            <S.ListItemText>My Vouchers</S.ListItemText>
            <img src={IconAngleRight} width={10} style={S.FaRight} />
          </ListGroup.Item>
        </Link>
        <Link to={wishListUrl}>
          <ListGroup.Item>
            <img src={IconWishList} width={14} />
            <S.ListItemText>My WishList</S.ListItemText>
            <img src={IconAngleRight} width={10} style={S.FaRight} />
          </ListGroup.Item>
        </Link>
        <Link to={shareUrl}>
          <ListGroup.Item>
            <img src={IconUsers} width={16} />
            <S.ListItemText>Refer Friends</S.ListItemText>
            <img src={IconAngleRight} width={10} style={S.FaRight} />
          </ListGroup.Item>
        </Link>
        <Link to={changePasswordUrl}>
          <ListGroup.Item>
            <img src={IconLock} width={14} />
            <S.ListItemText>Change Password</S.ListItemText>
            <img src={IconAngleRight} width={10} style={S.FaRight} />
          </ListGroup.Item>
        </Link>
        <Link to={contactUrl}>
          <ListGroup.Item>
            <img src={IconIdCard} width={16} />
            <S.ListItemText>Contact Detail</S.ListItemText>
            <img src={IconAngleRight} width={10} style={S.FaRight} />
          </ListGroup.Item>
        </Link>
        <Link to={mstiTestUrl}>
          <ListGroup.Item>
            <img src={IconSearch} width={14} />
            <S.ListItemText>MSTI Skincare Finder</S.ListItemText>
            <img src={IconAngleRight} width={10} style={S.FaRight} />
          </ListGroup.Item>
        </Link>
        <Link to={baseUrl} onClick={logOut}>
          <ListGroup.Item>
            <img src={IconLogout} width={14} />
            <S.ListItemText>Log Out</S.ListItemText>
            <img src={IconAngleRight} width={10} style={S.FaRight} />
          </ListGroup.Item>
        </Link>
      </ListGroup>
    </S.Wrapper>
  );
};

export { MyAccountMenu };
